// extracted by mini-css-extract-plugin
module.exports = {"block":"genre-grid-block_block_B8y5Y","blockPadded":"genre-grid-block_blockPadded_3FWac"};